module.exports = __webpack_public_path__ + "img/ubp.df5e615e.png";